import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-copyright">
          © 2026 {t('appName')}
        </div>
        <div className="footer-links">
          <a 
            href="https://upsanddowns.life/privacy-policy/" 
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            {t('privacyPolicy')}
          </a>
          <span className="footer-separator">|</span>
          <a 
            href="https://upsanddowns.life/terms-and-conditions/" 
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            {t('termsAndConditions')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

